var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let ActionDialogLayout = class ActionDialogLayout extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.currentStep = 1;
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onPrevious() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }
    onNext() {
        if (this.currentStep < this.options.steps.length) {
            this.currentStep++;
        }
    }
    onGoToStep(step) {
        if (step < 1 || step > this.options.steps.length) {
            return;
        }
        this.currentStep = step;
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get isFirst() {
        return this.currentStep === 1;
    }
    get isLast() {
        return this.currentStep === this.options.steps.length;
    }
    // #endregion
    // #region @Watchers
    onCurrentStepChange(newValue) {
        this.$emit('update:currentStep', newValue);
    }
};
__decorate([
    Prop({ default: () => ({ steps: [] }) }),
    __metadata("design:type", Object)
], ActionDialogLayout.prototype, "options", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], ActionDialogLayout.prototype, "isDisabled", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ActionDialogLayout.prototype, "onCurrentStepChange", null);
ActionDialogLayout = __decorate([
    Component({})
], ActionDialogLayout);
export default ActionDialogLayout;
// #endregion
// #region Constants
// #endregion
